<template lang="pug">
nav#site-nav
  router-link(:to="{ name: 'defaultScene', params: { path: '/' }}" class="brand logo medium" :style="'background-image: url(' + this.logo + ')'" )

  div.nav-items-container
    //- div.nav-icon#contact(@click="this.handleContact")
      span.icon.icon-contact
    a.nav-icon#signin(href="https://connect.digigurus.net/sign_in")
      span.icon.icon-signin(style="background-image: url('./assets/img/icon-signin.svg')") Sign in
    div.nav-icon.small(@click="this.toggleNavVisibility")
      span.nav-icon-bar
      span.nav-icon-bar
      span.nav-icon-bar
    ol.nav-items(:class="this.navVisible ? 'shown' : 'hidden'")
      li(v-for="(n, i) in filteredPages" class="item" v-bind:css="true" :key="'nav_item' + i" @click="toggleNavVisibility")
        a(v-if="n.directRef" :href="n.directRef" :name="n.name") {{n.name}}
        router-link(v-if="!n.directRef" :to="{ name: 'pageScene', params: { page: n.slug }}") {{ n.name }}
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import anime from 'animejs'
import router from '@/router'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var Navigation = Vue.component('navigation', {
  name: 'Navigation',
  props: [''],
  data: function () {
    return {
      navVisible: false
    }
  },
  watch: {
    'pages': function () {
      // console.log(this.pages)
    }
  },
  methods: {
    ...mapActions([
      'getEntry'
    ]),
    toggleNavVisibility (event) {
      // console.log('toggle nav')
      this.navVisible = !this.navVisible
    },
    handleContact (event) {
      this.toggleNavVisibility()
      router.push({name: 'pageScene', params: {page: 'contact'}})
    }
  },
  computed: {
    logo () {
      // swiches logo based on page ( index = exception)
      return this.appData && this.appData.root ? this.$route.name === 'defaultScene' ? this.appData.root.fields.logoAlt.file.url : this.appData.root.fields.logo.file.url : null
    },
    filteredPages () {
      let filtered = {}

      for (var n in this.pages) {
        // console.log(n)
        this.pages[n].navigation && Vue.set(filtered, this.pages[n].slug, this.pages[n])
      }

      return filtered
    },
    ...mapGetters([
      'appData',
      'domain',
      'pages'
    ]),
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              // console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Navigation
</script>

<style lang="scss" scoped>
  // exception for logo styling on defaultScene i.e index
  #app .main-container.index nav .logo{
    margin-top: calc(#{measure(xxs, true)} - #{measure(xs)});

    @include breakpoint(xlarge) {
      margin-top: measure(m);
    }
    @include breakpoint(medium only) {
      margin-top: calc(#{measure(xxs)} + 8px);
    }
  }

  nav{
    .nav-icon{
      display: block;
      position: relative;
      cursor: pointer;
      z-index: 10;

      width: measure(s);
      height: measure(s);
      background-color: get-color(secondary);
      border-radius: 9999px;

      margin: 0 measure(s) #{measure(xxs) / 2};

      // @include breakpoint (medium) {
      //   display: none;
      // }

      .icon{

      }

      &.small{
        width: measure(xs);
        height: measure(xs);

        margin-right: #{measure(s) + measure(xxs) / 2};

        .nav-icon-bar{
          &:nth-child(1){top: calc(40% + -1px)}
          &:nth-child(2){top: calc(40% + 3px)}
          &:nth-child(3){top: calc(40% + 7px)}
        }
      }

      &:hover{
        background: get-color(secondary-plus1);

        .nav-icon-bar{
          &:nth-child(1){width: #{40% * .55};}
          &:nth-child(2){width: 40% * .75;}
          &:nth-child(3){width: #{40%};}
        }
      }

      .nav-icon-bar{
        position: absolute;
        width: 40%;
        height: 2px;
        border-radius: 9999px;
        background-color: get-color(primary);

        transition: width .1s ease-in;

        &:nth-child(1){top: calc(40% + -1px);  left: 32%; width: #{40% * .75};}
        &:nth-child(2){top: calc(40% + 4px); left: 32%; width: 40%;}
        &:nth-child(3){top: calc(40% + 9px); left: 32%; width: #{40% * .55};}
      }
    }
    &#site-nav{
      position: absolute;
      top: measure(xs);
      left: 0;
      width: 100%;
      height: 100px;
      // padding: 0 measure(sm);

      .nav-items-container{
        position: fixed;
        z-index: 9999;
        top: measure(s);
        right: 0;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        align-items: flex-end;
        flex-wrap: nowrap;
        // flex-flow: column no-wrap;
      }

      .logo{
        margin-left: calc(#{measure(xxs, true)} + 4px);
        margin-top: calc(#{measure(xxs)} + 8px);
        min-width: measure(m);
      }

      ol, ul, .nav-items{
        margin-top: measure(xxs);
        margin-right: measure(s);
        // transition: opacity .3s ease-in-out;
        opacity: 1;
        width: 100px;
        flex-wrap: wrap;
        justify-content: flex-end;

        &.shown{
          li, li.item{ opacity: 1; transform: translate(0rem, 0)}
        }
        &.hidden{
          li, li.item{ opacity: 0; transform: translate(1rem, 0)}
        }

        @include breakpoint (small only) {
          top: measure(sm);
        }

        @for $i from 1 through 10 {
          li:nth-child(#{$i}) {
            transition: opacity .2s #{.05 * $i}s ease-in-out, transform .2s #{.05 * $i}s ease-in-out;
          }
        }
        li, li.item{
          // transition: opacity .2s ease-in-out;
        }
        li a, li.item a{

          margin:0 -#{measure(m)} measure(xxs) 0;
          padding: 0 (measure(m) + .7) 0 measure(xs);
          background:get-color(secondary);
          white-space: nowrap;

          text-transform: uppercase;

          // border: none;
          font-size: font-measure(s) + .1;
          font-family: $font-family-monospace;
          border-radius: 999px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue